module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "client_menu",
    attrs: {
      "default-active": _vm.defaultActive,
      "mode": "horizontal"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.url
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21e8354c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/Tabs.vue
// module id = 401
// module chunks = 0